<div class="ui-project__header">
  <div class="actions__buttons">
    <list-search />

    <list-filters-btn-v2 [filters]="ProjectContactsFiltersComponent" class="ml-auto" />
  </div>
</div>

<div class="container-fluid--30 pt-3">
  <app-list
    *ngIf="inited"
    [config]="config"
    [emptyTemplate]="emptyTemplate"
    [filters]="ProjectContactsFiltersComponent"
    [searchName]="'ProjectContacts.List.search' | translate"
    [selected]="selected"
    [showToggleMenu]="showToggleMenu.bind(this)"
    #list
  />
</div>

<ng-template #emptyTemplate>
  <div class="d-flex flex-column align-items-center mt-4 empty">
    <img
      draggable="false"
      src="/assets/img/team-placeholder-icon.svg"
      alt="{{ 'ProjectChanges.List.noRecords' | translate }}"
      class="mb-4 mt-4"
    />
    <div class="mt-2">{{ 'ProjectTeam.List.noRecords' | translate }}</div>
    <app-button
      [permission]="{ group: PermissionsGroups.PROJECT_CONTACTS, action: 'ADD' }"
      (onClick)="addNewContact()"
      [config]="{
        size: ButtonSize.SMALL,
        type: ButtonTypes.SECONDARY_BLUE,
        text: 'ProjectTeam.addNewTeamMember' | translate,
        prependSrc: './assets/img/ic-user-plus.svg'
      }"
    />
  </div>
</ng-template>

<project-contact-name-cell #projectContactNameCellComponent />
<project-contact-type-cell #projectContactTypeCellComponent />
<project-contact-phone-cell #projectContactPhoneCellComponent />
<project-contact-email-cell #projectContactEmailCellComponent />
<project-contact-function-cell #projectContactFunctionCellComponent />
<project-contact-role-cell #projectContactRoleCellComponent />
